import React,{lazy } from 'react';

const Home = lazy(()=> import('../pages/index'));

const routing:any = [
    // auth only
    {path:'/', component:Home},
    {path:'/aws/registration/', component:Home},
    {path:'/azure/registration/', component:Home},
    {path:'/gcp/registration/', component:Home},
    
];

export default routing;